import App from './PIDiagramApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iPIDiagram', <App />);
